import React, { useState, useEffect } from "react";
import { FaPen, FaTrash } from "react-icons/fa";

import './styles.css';

import BankAccountPopUp from '../../Records/BankAccountsCard/BankAccountPopUp'
import bankAccountServices from "../../../../services/admFin/bankAccountServices";
import formatterBR, { formatter } from "../../../../functions/formatCurrency";

export default function BankAccountCard(props) {
    const [visibility, setVisibility] = useState(false);

    let formatterCurrency = props.bankAccount && props.bankAccount.moeda ? formatter(props.bankAccount.moeda) : formatterBR;

    async function deleteBankAccount(id, setElements) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm("Deseja deletar esta Conta Bancária?")) {
            try {
                await bankAccountServices.deleteBankAccount(id);
                setElements(oldArray => {
                    const temp = [...oldArray];
                    return temp.filter(obj => obj.id !== id);
                })
            } catch (err) {
                alert("Erro ao deletar Conta Bancária");
            }
        }
    }

    async function editBankAccount(bankAccount) {
        if (!bankAccount.banco || !bankAccount.agencia || !bankAccount.numero || !bankAccount.tipo || !bankAccount.saldo || bankAccount.moeda === "") {
            alert("Os campos devem estar preenchidos");
            return;
        }
        try {
            const response = await bankAccountServices.patchBankAccount(props.bankAccount.id, bankAccount.banco, bankAccount.agencia, bankAccount.numero, bankAccount.tipo, bankAccount.moeda,parseFloat(bankAccount.saldo));
            props.setBankAccounts(oldArray => {
                return oldArray.map(obj => {
                    if (obj.id === props.bankAccount.id)
                        return response.data;
                    else
                        return obj;
                })
            })
            setVisibility(false);
        } catch (err) {
            alert("Não foi possível editar a conta bancária")
        }
    }
    return (
        <li className="bank-accounts-page-card">
            <h4>{props.bankAccount.banco}</h4>
            <p><b>Agência: </b>{props.bankAccount.agencia}</p>
            <p><b>Número: </b>{props.bankAccount.numero}</p>
            {/* <p><b>Saldo Inicial: </b>{props.bankAccount.saldo_inicial}</p> */}
            <span className={`tag large  ${props.bankAccount.saldo > 0 ? "green" : "red"}`}>
                <b>Saldo:</b>
                {formatterCurrency.format(props.bankAccount.saldo)}
            </span>
            <div className="bank-accounts-page-card-buttons-container">
                <button onClick={() => setVisibility(true)}><FaPen /></button>
                <BankAccountPopUp
                    visibility={visibility}
                    setVisibility={setVisibility}
                    tittle="Editar Conta Bancária"
                    buttonTittle="Editar"
                    bankAccount={props.bankAccount}
                    onClick={editBankAccount}

                />
                <button className="red" onClick={() => deleteBankAccount(props.bankAccount.id, props.setBankAccounts)}><FaTrash /></button>
            </div>
        </li>
    )
}